import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import ProductCard from '@magalu/stereo-ui/organisms/ProductCard';
import PropTypes from 'prop-types';
import { Image, Box, Flex, Text, Link } from '@magalu/stereo-ui/atoms';
import { Icon } from '@magalu/stereo-ui-icons';
import withLayoutProps from '../../../../hocs/withLayoutProps';
import AdsBrandBanner from '../AdsBrandBanner';
import { FlexList } from './AdsBrandsMobile.styles';
var AdsBrandsMobile = function AdsBrandsMobile(_ref) {
  var _brand$content3, _brand$content4, _brand$content5, _brand$content6, _brand$content7, _brand$content8;
  var adsPath = _ref.adsPath,
    brand = _ref.brand,
    handleBrandClick = _ref.handleBrandClick,
    handleBrandImpression = _ref.handleBrandImpression,
    isVideo = _ref.isVideo,
    handleProductClick = _ref.handleProductClick,
    handleProductView = _ref.handleProductView,
    marginBottom = _ref.marginBottom,
    marginTop = _ref.marginTop;
  var inViewConfig = useMemo(function () {
    return {
      threshold: 0.5,
      triggerOnce: true
    };
  }, []);
  var _useInView = useInView(inViewConfig),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  useEffect(function () {
    if (inView) {
      handleBrandImpression();
    }
  }, [inView]);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    parseAdsProducts = _useState2[0],
    setParseAdsProducts = _useState2[1];
  var brandRedirectUrl = useMemo(function () {
    var _brand$content;
    if (!(brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : _brand$content.redirectUrl)) return null;
    try {
      var _brand$content2;
      var url = new URL(brand == null ? void 0 : (_brand$content2 = brand.content) == null ? void 0 : _brand$content2.redirectUrl);
      url.searchParams.append('track_id', brand == null ? void 0 : brand.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [brand]);
  var banner = {
    imageUrl: brand == null ? void 0 : (_brand$content3 = brand.content) == null ? void 0 : _brand$content3.imageUrl,
    redirectUrl: brandRedirectUrl
  };
  useEffect(function () {
    if (brand == null ? void 0 : brand.products.length) {
      var _brand$products;
      brand == null ? void 0 : (_brand$products = brand.products) == null ? void 0 : _brand$products.forEach(function (product, index) {
        setParseAdsProducts(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            allowEmptyRatting: true,
            campaignId: brand.campaignId,
            category: product.category,
            hidePrice: true,
            hidePriceMode: 'hide',
            id: product.id,
            image: product == null ? void 0 : product.image,
            installment: product == null ? void 0 : product.installment,
            path: '/',
            position: index + 1,
            price: product == null ? void 0 : product.price,
            rating: product == null ? void 0 : product.rating,
            seller: product.seller,
            subcategory: product.subcategory,
            title: product == null ? void 0 : product.title,
            url: product == null ? void 0 : product.path
          }]);
        });
      });
    }
  }, [brand]);
  if (!brand) return null;
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    ref: ref,
    bg: "white",
    width: "100%",
    maxHeight: "396px",
    padding: "8px",
    borderRadius: "8px",
    "data-testid": "ads-sponsored-brands",
    marginTop: marginTop,
    marginBottom: marginBottom
  }, React.createElement("span", {
    "data-testid": "ads-banner_screenshot",
    "ads-screenshot-id": "ads-banner_".concat(brand == null ? void 0 : brand.slot, "_").concat(brand == null ? void 0 : brand.campaignId)
  }), React.createElement(Flex, {
    flexDirection: "column",
    gap: "8px"
  }, React.createElement(Flex, null, React.createElement(Text, {
    color: "text.scratched",
    fontSize: "10px"
  }, "Patrocinado")), React.createElement(Flex, {
    alignItems: "center",
    columnGap: 2
  }, React.createElement(Image, {
    lazy: true,
    cover: true,
    src: brand == null ? void 0 : (_brand$content4 = brand.content) == null ? void 0 : _brand$content4.logo,
    style: {
      height: '27px',
      width: '85px'
    }
  }), React.createElement(Flex, {
    flexDirection: "column",
    rowGap: 1
  }, React.createElement(Text, {
    fontSize: "14px",
    fontWeight: "bold"
  }, brand == null ? void 0 : (_brand$content5 = brand.content) == null ? void 0 : _brand$content5.headline), React.createElement(Text, {
    fontSize: "14px"
  }, brand == null ? void 0 : (_brand$content6 = brand.content) == null ? void 0 : _brand$content6.subtitle), React.createElement(Link, {
    onMouseDown: handleBrandClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    "data-testid": "blog-ecommerce-link",
    href: brandRedirectUrl
  }, React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center",
    columnGap: 2
  }, React.createElement(Text, {
    color: "primary.dark",
    fontSize: "14px",
    fontWeight: "bold"
  }, (brand == null ? void 0 : (_brand$content7 = brand.content) == null ? void 0 : _brand$content7.buttonTitle) || 'Ver mais'), React.createElement(Icon, {
    color: "primary.dark",
    name: "ChevronRight",
    height: "14px",
    width: "14px"
  }))))), (brand == null ? void 0 : (_brand$content8 = brand.content) == null ? void 0 : _brand$content8.imageUrl) && React.createElement(AdsBrandBanner, {
    adsPath: adsPath,
    banner: banner,
    isVideo: isVideo,
    handleBrandClick: handleBrandClick,
    width: "100%",
    height: 176,
    styles: {
      borderRadius: 8
    }
  }), (parseAdsProducts == null ? void 0 : parseAdsProducts.length) > 0 && React.createElement(FlexList, null, parseAdsProducts.map(function (product) {
    return React.createElement(ProductCard, _extends({
      key: product.id,
      onView: handleProductView,
      onMouseDown: handleProductClick,
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      fullHeight: true,
      showDiscount: false,
      showDiscountOnlyCashInfo: false,
      hideOriginalPrice: true,
      showRating: false,
      displayMode: "sponsoredBrand"
    }, product));
  })))));
};
AdsBrandsMobile.defaultProps = {
  adsPath: '',
  brand: {
    campaignId: '',
    content: {
      buttonTitle: '',
      headline: '',
      imageUrl: '',
      logo: '',
      redirectUrl: '',
      subtitle: ''
    },
    products: [],
    template: '',
    trackId: ''
  },
  handleBrandClick: function handleBrandClick() {},
  handleBrandImpression: function handleBrandImpression() {},
  handleProductClick: function handleProductClick() {},
  handleProductView: function handleProductView() {},
  isVideo: false,
  marginBottom: '0px',
  marginTop: '0px'
};
process.env.NODE_ENV !== "production" ? AdsBrandsMobile.propTypes = {
  adsPath: PropTypes.string,
  brand: PropTypes.shape({
    campaignId: PropTypes.string,
    content: PropTypes.shape({
      buttonTitle: PropTypes.string,
      headline: PropTypes.string,
      imageUrl: PropTypes.string,
      logo: PropTypes.string,
      redirectUrl: PropTypes.string,
      subtitle: PropTypes.string
    }),
    products: PropTypes.arrayOf({}),
    slot: PropTypes.string,
    template: PropTypes.string,
    trackId: PropTypes.string
  }),
  handleBrandClick: PropTypes.func,
  handleBrandImpression: PropTypes.func,
  handleProductClick: PropTypes.func,
  handleProductView: PropTypes.func,
  isVideo: PropTypes.bool,
  marginBottom: PropTypes.string,
  marginTop: PropTypes.string
} : void 0;
AdsBrandsMobile.ssr = true;
export default withLayoutProps(AdsBrandsMobile);